import { NavigationPromptModal as NavigationModalBase } from '@lmc/ui-kit'
import { NAMESPACE } from 'locale'
import { generalConstants } from 'locale/general'
import { useTranslation } from 'react-i18next'

type NavigationModalProps = {
  canNavigate: boolean
  modalTitle?: string
  modalContentText?: string
  modalConfirmText?: string
  modalCancelText?: string
}

const NavigationModal = ({
  modalTitle,
  modalCancelText,
  modalConfirmText,
  modalContentText,
  ...props
}: NavigationModalProps) => {
  const { t } = useTranslation(NAMESPACE.GENERAL)

  return (
    <NavigationModalBase
      {...props}
      modalCancelText={modalCancelText || t(generalConstants.CANCEL)}
      modalConfirmText={
        modalConfirmText || t(generalConstants.EXIT_WITHOUT_SAVING)
      }
      modalTitle={modalTitle || t(generalConstants.MODAL_TITLE)}
      modalContentText={modalContentText || t(generalConstants.MODAL_CONTENT)}
    />
  )
}

export default NavigationModal
